import { TableHead, InputBoX } from "../../../../common/dataClass/Default"
import { ProductInfo } from "../../../../common/dataClass/Product";
import { productInfoKey } from '../newProductInfo/class'
import globalData from '../../../../common/globalData'

/**产品基本信息键值对对应表 */
let listingInfoKey = {
  'productTitle': 'title',
  'storeName': 'store',
  'countrySite': 'countrySite',
  'hsCode': 'HSCode',
  'brandName': 'brandName',
  'asin': 'asin',
  'sellerSku': 'sku',
  'productPrice': 'sellingPrice',
  'amazonCommissionRate': 'commission',
  'fnsku': 'fnSku',
  'upcString': 'upcOrEan',
  'upcLabel': 'barCodeByListing',
  'declaredValueOfGoodsForExport': 'saleTax',
  'importTariffRateOfGoods': 'sqrkgsl',
  'listingId': 'listingId'
}

/**选品利润预算表头 */
class ListingTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

class ListingSearch{
  constructor() {
    this.asin = null
    this.country = null
    this.store = null
  }
  get getListingListAxiosBody(){
    return {
      asin: this.asin? this.asin: null,
      country: this.country? this.country: null,
      storeName: this.store? this.store: null
    }
  }
}

class Listing extends ProductInfo{
  constructor(){
    super()
    this.listingId = ''
    /**商品标题 */
    this.title = ''
    /**店铺名称 */
    this.store = ''
    /**国家站点 */
    this.countrySite = ''
    /**HSCode */
    this.HSCode = ''
    /**品牌名称 */
    this.brandName = ''
    /**ASIN */
    this.asin = ''
    /**卖家SKU */
    this.sku = ''
    /**亚马逊销售单价 */
    this.sellingPrice = ''
    /**亚马逊销售佣金率 */
    this.commission = ''
    /**FNSKU */
    this.fnSku = ''
    /**商品UPC/EAN条码 */
    this.upcOrEan = ''
    /**条形码PDF文件 */
    this.barCodeByListing = ''
    /**商品出口申报价值 */
    this.saleTax = ''
    /**商品入口关税率 */
    this.sqrkgsl = ''
    /**完成状态 */
    this.finishStatus = ''
    /**FBA可售数量 */
    this._FBANum = ''
  }
  /**导入后端返回的列表数据 */
  backendListDataParsing(obj){
    this.backendListDataParsingByProduct(obj)
    let lKeys = Object.keys(listingInfoKey)
    lKeys.map(key => {
      this[listingInfoKey[key]] = obj[key]
    })
  }
  backendListDataParsingByProduct(obj){
    let pKeys = Object.keys(productInfoKey)
    let pStatus = obj.productStatus ? obj.productStatus: []
    pKeys.map(key => {
      this[productInfoKey[key]] = String(obj[key])
    })
    this.productStatus = pStatus.map(index => globalData.productStatusInputOptions[index])
  }
  set FBANum(value){ this._FBANum = value }
  get FBANum(){
    return this._FBANum ? this._FBANum : '------'
  }
  /**父ASIN */
  get fatherAsin(){
    return '------'
  }
  /**商品标题/ASIN/卖家SKU */
  get titleAndAsinAndSku(){
    return this.title + '<br>' + this.asin + '  ' + this.sku
  }
  /**商品名称/FNSKU */
  get nameAndFnsku(){
    return this.name + '<br>' + this.fnsku
  }
  /**仓库合集 */
  get repositoryAndCollection(){
    return '---- / ---- / ----<br> ---- / ----'
  }
  /**近三期销量 */
  get lastThreeSales(){
    return '---- / ---- / ----'
  }
  /**近三期销售额 */
  get lastThreeSalesRecent(){
    return '---- / ---- / ----'
  }
  /**获取国家站点名称 */
  get getCountryName(){
    return globalData.countrySiteInputOptions[this.countrySite]
  }
  /**新建listing请求体 */
  get getNewListingBody(){
    let obj = {
      'productId': this.id,
      'storeId': this.store,
      'countrySite': this.countrySite,
      'asin': this.asin,
      'sellerSku': this.sellerSku,
      'fnsku': this.fnSku,
      'amazonCommissionRate': this.commission,
      'upcLabel': this.barCodeByListing,
      'upcString': this.upcOrEan,
      'picture': this.img,
      'productTitle': this.title,
      'productPrice': this.sellingPrice,
      'hsCode': this.HSCode,
      'brandName': this.brandName,
      'declaredValueOfGoodsForExport': this.saleTax,
      'importTariffRateOfGoods': this.sqrkgsl,
    }
    return obj
  }
  /**修改listing请求体 */
  get getChangeListingBody(){
    let obj = {
      "listingId": this.listingId,
      'storeId': this.store,
      'countrySite': this.countrySite,
      'asin': this.asin,
      'sellerSku': this.sellerSku,
      'fnsku': this.fnSku,
      'amazonCommissionRate': this.commission,
      'upcLabel': this.barCodeByListing,
      'upcString': this.upcOrEan,
      'picture': this.img,
      'productTitle': this.title,
      'productPrice': this.sellingPrice,
      'hsCode': this.HSCode,
      'brandName': this.brandName,
      'declaredValueOfGoodsForExport': this.saleTax,
      'importTariffRateOfGoods': this.sqrkgsl,
    }
    return obj
  }
}

class ListingInputBox extends InputBoX{
  constructor(type, name, data, obj = { pla: '', isDisable: false, isRequired: true, unit: '', tips: '' }) {
    super(type, name, data, obj)
    /**无数据是否提示 */
    this.isPrompt = false
    /**是否必填 */
    this.isRequired = obj.isRequired == undefined ? true : obj.isRequired
    /**后面显示单位 */
    this.unit = obj.unit
    /**输入框前面的icon */
    this.preIcon = obj.preIcon ? obj.preIcon : ''
    /**输入框后面的icon */
    this.sufIcon = obj.sufIcon ? obj.sufIcon : ''
  }
}

class ListingNewModule{
  /**创建进度条数据 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '选择要新建listing的产品',
      '补充listing信息',
      '发布listing信息',
    ]
    return arr
  }
  /**产品表头 */
  static NEWPRRODUCTTABLEHEAD(){
    let arr = [
      new ListingTableHead('选择', 'radio', '40'),
      new ListingTableHead('产品图片', 'img', '100'),
      new ListingTableHead('产品ID/型号', 'model', '120'),
      new ListingTableHead('产品名称', 'name', '150'),
      new ListingTableHead('产品分类', 'sort', '180'),
      new ListingTableHead('产品状态', 'status', '150'),
      new ListingTableHead('计价<br>单位', 'unit', '50'),
      new ListingTableHead('产品包装尺寸<br>(cm)', 'productSize', '150'),
      new ListingTableHead('产品包装重量<br>(kg/单位)', 'weight', '150'),
      new ListingTableHead('外箱包装尺寸<br>(cm)', 'boxSize', '150'),
      new ListingTableHead('外箱包装重量<br>(kg/单位)', 'boxWeight', '150'),
      new ListingTableHead('装箱数量<br>(单位/箱)', 'boxNum', '80'),
    ]
    return arr
  }
  /**产品基本信息输入框 */
  static NEWBASICINFO(){
    let arr = [
      {
        id: new ListingInputBox('text', '商品型号', 'model', { isDisable: true }),
        name: new ListingInputBox('text', '商品名称', 'name', { isDisable: true }),
        sort: new ListingInputBox('select', '商品分类', 'sort', { isDisable: true }),
        productStatus: new ListingInputBox('select', '商品状态', 'productStatus', { isDisable: true }),
        unit: new ListingInputBox('select', '计价单位', 'unit', { isDisable: true }),
      },
      {
        size: new ListingInputBox('text', '商品包装尺寸', 'size', { isDisable: true, unit: '(cm)' }),
        weight: new ListingInputBox('number', '商品包装重量', 'weight', { isDisable: true, unit: '(kg/箱)' }),
        boxSize: new ListingInputBox('text', '外箱包装尺寸', 'boxSize', { isDisable: true, unit: '(cm)' }),
        boxWeight: new ListingInputBox('number', '外箱包装重量', 'boxWeight', { isDisable: true, unit: '(kg/箱)' }),
        boxNum: new ListingInputBox('number', '装箱数量', 'boxNum', { isDisable: true, unit: '(/箱)' }),
      }
    ]
    return arr
  }
  /**产品包装尺寸 */
  static NEWSIZE(){
    let arr = [
      new ListingInputBox('input', '长', 'long'),
      new ListingInputBox('input', '宽', 'width'),
      new ListingInputBox('input', '高', 'height'),
    ]
    return arr
  }
  /**外箱包装尺寸 */
  static NEWBOXSIZE(){
    let arr = [
      new ListingInputBox('input', '长', 'boxLong'),
      new ListingInputBox('input', '宽', 'boxWidth'),
      new ListingInputBox('input', '高', 'boxHeight'),
    ]
    return arr
  }
  /**listing信息输入框 */
  static LISTINGINFOINPUTMODULE(){
    let arr = [
      {
        store: new ListingInputBox('select', '店铺名称', 'store', { isRequired: true }),
        countrySite: new ListingInputBox('select', '国家站点', 'countrySite', { isRequired: true }),
        HSCode: new ListingInputBox('number', 'HSCode', 'HSCode', { isRequired: true }),
        brandName: new ListingInputBox('text', '品牌名称', 'brandName', { isRequired: true }),
      },
      {
        asin: new ListingInputBox('text', 'ASIN', 'asin', { isRequired: true }),
        sku: new ListingInputBox('text', '卖家SKU', 'sku', { isRequired: true }),
        sellingPrice: new ListingInputBox('number', '亚马逊销售单价', 'sellingPrice', { isRequired: true }),
        commission: new ListingInputBox('number', '亚马逊销售佣金率', 'commission', { isRequired: true, sufIcon: 'icon-baifenbi' }),
      },
      {
        fnSku: new ListingInputBox('text', 'FNSKU', 'fnSku', { isRequired: true }),
        upcOrEan: new ListingInputBox('text', '商品UPC/EAN条码', 'upcOrEan', { isRequired: true }),
        barCodeByListing: new ListingInputBox('text', '条形码PDF文件', 'barCodeByListing', { isRequired: true, pla: '备注：限亚马逊后台下载的PDF格式文档', isDisable: true }),
        saleTax: new ListingInputBox('number', '商品出口申报价值', 'saleTax', { isRequired: true, preIcon: 'icon-el-inco-cmoney' }),
        sqrkgsl: new ListingInputBox('number', '商品入口关税率', 'sqrkgsl', { isRequired: true, sufIcon: 'icon-baifenbi' }),
      },
    ]
    return arr
  }
  /**Listing表头 */
  static NEWLISTINGTABLEHEAD(){
    let arr = [
      new ListingTableHead('图片', 'img', '100'),
      new ListingTableHead('父ASIN', 'fatherAsin', '120'),
      new ListingTableHead('商品标题/ASIN/卖家SKU', 'titleAndAsinAndSku', '150'),
      new ListingTableHead('商品名称/FNSKU', 'nameAndFnsku', '120'),
      new ListingTableHead('店铺名称', 'store', '80'),
      new ListingTableHead('国家站点', 'getCountryName', '80'),
      new ListingTableHead('计价<br>单位', '_unit', '50'),
      new ListingTableHead('售价<br>(Your Price)', 'sellingPrice', '100'),
      new ListingTableHead('FBA可售数量', 'FBANum', '100'),
      new ListingTableHead('生产中/国内中转仓/海外中转仓<br>国际运输中/合计未入亚马逊仓库库存量', 'repositoryAndCollection', '250'),
      new ListingTableHead('近三期销量', 'lastThreeSales', '80'),
      new ListingTableHead('近三期销售额', 'lastThreeSalesRecent', '80'),
      new ListingTableHead('排名', 'FBANum', '80'),
      new ListingTableHead('Review数量/星数', 'FBANum', '120'),
      new ListingTableHead('创建/更新时间', 'time', '80'),
      new ListingTableHead('备注', 'finishStatus', '80'),
      new ListingTableHead('操作', 'operate', '80'),
    ]
    return arr
  }
}
export { ListingNewModule, Listing, ListingSearch }
